import React, { Component } from "react";
import { languageService } from "Language/language.service";
export const LocationPrefixListHeader = (props) => {
  return (
    <div className="location-prefix-list-header">
      <h5>{languageService("Locations")}</h5>
    </div>
  );
};
export const LocationPrefixHeader = (props) => {
  return (
    <div className="location-prefix-header">
      <h5>{props.value ? props.value : languageService("No Selected Location")}</h5>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LocationPrefixEditor/LocationPrefixTopBar.jsx